'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dict;

var _styledSystem = require('styled-system');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var clean = function clean(props) {
  var rebassProps = (0, _styledSystem.removeProps)(props);
  var next = {};

  for (var key in rebassProps) {
    if (dict[key]) continue;
    next[key] = rebassProps[key];
  }

  return next;
};

var dict = (_dict = {
  active: true,
  ratio: true,
  bold: true,
  caps: true,
  size: true,
  left: true,
  center: true,
  right: true,
  justify: true,
  top: true
}, _defineProperty(_dict, 'right', true), _defineProperty(_dict, 'bottom', true), _defineProperty(_dict, 'left', true), _defineProperty(_dict, 'z', true), _defineProperty(_dict, 'backgroundImage', true), _dict);

exports.default = clean;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/clean-props.js
// module id = ./node_modules/rebass/dist/clean-props.js
// module chunks = 0